/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHeartPin = createReactComponent("heart-pin", "IconHeartPin", [
  [
    "path",
    {
      d: "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.5 5.179",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 18v.01", key: "svg-2" }]
]);

export { IconHeartPin as default };
//# sourceMappingURL=IconHeartPin.js.map
